import { AdaptivePanel } from '@/components/properties/adaptive/AdaptivePanel';
import { SlideBackgroundEditor } from '@/components/properties/SlideBackgroundEditor';
import { Input } from '@/components/ui/Input';
import { Section } from '@/components/ui/Section';
import { Select } from '@/components/ui/Select';
import type { Slide } from '@/lib/schema.types';
import { useEditorActions, useEditorStore } from '@/store/editor.store';

export function SlideProperties({ slide }: { slide: Slide }) {
  const actions = useEditorActions();
  // Only pack-mode slides carry `beatMeta`; only those get the Adaptive
  // surface. Scripts stay byte-identical (no extra sections).
  const mode = useEditorStore((s) => s.mode);
  const showAdaptive = mode === 'pack' && Boolean(slide.beatMeta);

  return (
    <>
      <Section title="Slide">
        <Input
          label="Label"
          value={slide.label}
          onChange={(e) => actions.updateSlide(slide.id, { label: e.target.value })}
        />
      </Section>
      <SlideBackgroundEditor
        value={slide.background}
        onChange={(bg) => actions.updateSlide(slide.id, { background: bg })}
      />
      <Section title="Transition">
        <Select
          value={slide.transition ?? 'fade'}
          onChange={(e) => actions.updateSlide(slide.id, { transition: e.target.value })}
        >
          <option value="none">None</option>
          <option value="fade">Fade</option>
          <option value="slide">Slide</option>
          <option value="scale">Scale</option>
        </Select>
      </Section>

      {showAdaptive && <AdaptivePanel slide={slide} />}
    </>
  );
}
